import React, { useState } from 'react';
import cn from 'classnames';
import Modal from "../../ui/Modal";
import EnergyEfficiencyLabels from './components/EnergyEfficiencyLabels';
import styles from './EnergyLabel.module.scss';
const EnergyLabel = ({ energyClass, energyLetter, energySupSign, energyClassCode, energyClassIntervalCode, energyClassInterval, energyDrawerTitle, compatible, energyImageNumber, articleId, arrowDirection, hmName, hmLongName, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const energyClassCodeStyleName = `class${energyClassCode}`;
    const ariaLabelString = `${compatible} ${energyClassInterval}`;
    // TODO: Algin how we receive data for PDP and PLP
    // if data from props energyLetter and energySupSign are not passed, get values from energyClass prop
    const extractedEnergySupSign = `${energyClass}`.slice(1);
    if (!energyLetter) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: cn(styles.energyLabel, styles[energyClassCodeStyleName], arrowDirection === 'left' ? styles.left : styles.right), "aria-label": ariaLabelString, onClick: () => setIsOpen(true) },
            React.createElement("span", null, energyLetter),
            (energySupSign && React.createElement("sup", null, energySupSign)) ||
                (extractedEnergySupSign && React.createElement("sup", null, extractedEnergySupSign))),
        React.createElement(Modal, { modalType: "stickyRight", closeButtonText: "Close", isOpen: isOpen, toggleModal: () => {
                setIsOpen(!isOpen);
            }, title: energyDrawerTitle },
            React.createElement(EnergyEfficiencyLabels, { energyClassIntervalCode: energyClassIntervalCode, compatible: compatible, energyImageNumber: energyImageNumber, articleId: articleId, hmName: hmName, hmLongName: hmLongName }))));
};
export default EnergyLabel;
//# sourceMappingURL=EnergyLabel.js.map